<template>
    <login-component>
    </login-component>
</template>

<script>
import loginComponent from '@/components/login/loginComponent.vue'
export default {
    components: {
    loginComponent
  }    
}
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/containers/login.vue